import { AbstractControl } from "@angular/forms";

export function ValidatorDecimalInput(
  control: AbstractControl
): { [key: string]: any } | null {
  const value = control.value;
  if (
    value &&
    (isNaN(control.value) ||
      (!isNaN(value) &&
        value.toString().includes(".") &&
        value.toString().split(".")[1].length > 2))
  ) {
    return { invalidInput: value };
  }
  return null;
}
